module.exports = __webpack_public_path__ + "img/Maskgroup.201a2a5a.png";